var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownChevronIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0004 12.8176L18.4855 5.6332C18.6703 5.45273 18.9754 5.45702 19.1645 5.64179L20.4793 6.92656C20.6684 7.11132 20.6727 7.4121 20.4879 7.59257L11.3484 16.3668C11.2539 16.4613 11.125 16.5043 11.0004 16.4957C10.8715 16.5 10.7469 16.457 10.6523 16.3668L1.51288 7.59257C1.32812 7.4121 1.33241 7.11132 1.52148 6.92656L2.83632 5.64179C3.02538 5.45702 3.33046 5.45273 3.51523 5.6332L11.0004 12.8176Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownChevronIcon);
export default __webpack_public_path__ + "static/media/down_chevron_icon.a43eee7d2263500e602419b0bffdd79c.svg";
export { ForwardRef as ReactComponent };